import script from "./RDTeam.vue?vue&type=script&setup=true&lang=ts"
export * from "./RDTeam.vue?vue&type=script&setup=true&lang=ts"

import "./RDTeam.vue?vue&type=style&index=0&id=08e0c05b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08e0c05b"]])

export default __exports__